import {createSinglePathSVG} from './TEMPLATE'

// Diagonal pill/capsule shape: two semicircular caps (r=5) connected by straight sides,
// oriented at 45°, centered in a 24×24 viewBox.
export const Capsule_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M14 3A5 5 0 0 1 21 10L10 21A5 5 0 0 1 3 14Z',
})
